import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { toJS } from '../to-js';
import { triggerAction, clearActionTriggeredState, invokeActionRules } from '../../actions/workflow-actions';
import { getCompanyDetails, getCustomIcons } from '../../actions/company';
import ActionElementGateway from '../../components/workflow/action/ActionElementGateway';

const mapStateToProps = (state, ownProps) => {
    const { action } = ownProps;
    if (typeof state.get === 'undefined') return {};
    return {
        translate: getTranslate(state.get('locale')),
        customIcons: state.getIn(['company', 'icons']),
        companyDetails: state.getIn(['company', 'details'])
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const { action, tid, workflow, typeModelId, containerId, columnIndex} = ownProps;
    return {
        getCustomIcons: payload => {
            dispatch(getCustomIcons(payload));
          },
           getCompanyDetails: () => {
                      dispatch(getCompanyDetails());
              },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(ActionElementGateway));